import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { AccountOrganisationDataService } from '../services/userOrganisation/AccountOrganisationDataService';

export const withOrganisationLogo = (WrappedComponent) => {
  const WithOrganisationLogo = (props) => (
    <WrappedComponent
      {...props}
      organisationInfo={AccountOrganisationDataService.getInstance().accountOrganisationData}
    />
    );
  hoistNonReactStatics(WithOrganisationLogo, WrappedComponent);
  return WithOrganisationLogo;
};
